import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./SendReceiptContent.module.scss";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import Spin from "components/Spin/Spin";

const PAGE_LOCALE_KEY = "page.transactions.sharedComponents.sendReceipt.";

const SendReceiptContent = ({ isLoading, handleInput, data }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <OutlinedText
          label={t(PAGE_LOCALE_KEY + "dialog.content.1")}
          noErrorMessage
          defaultValue={data.customerEmail ? data.customerEmail : ""}
          onchangeFn={(e) => textInputOnchange(e, "customerEmail")}
          onfocusFn={() => textInputOnFocus("customerEmail")}
          onblurFn={() => textInputOnBlur("customerEmail")}
          sxParams={{ textFocus: focus.customerEmail }}
        />
      </div>
      {isLoading && (
        <div className={s.spinContainer}>
          <Spin type={"search"} />
        </div>
      )}
    </div>
  );
};

export default SendReceiptContent;
